import StarterKit from '@tiptap/starter-kit';
import Highlight from '@tiptap/extension-highlight';
import Underline from '@tiptap/extension-underline';
import Placeholder from '@tiptap/extension-placeholder';
import TaskList from '@tiptap/extension-task-list';
import TaskItem from '@tiptap/extension-task-item';
import { TextStyle } from '@tiptap/extension-text-style';
import { Color } from '@tiptap/extension-text-style';
import Image from '@tiptap/extension-image';
import Typography from '@tiptap/extension-typography';
import Superscript from '@tiptap/extension-superscript';
import Subscript from '@tiptap/extension-subscript';
import CodeBlockLowlight from '@tiptap/extension-code-block-lowlight';
import { common, createLowlight } from 'lowlight';

// Secondary Sprint Extensions
import { Details, DetailsContent, DetailsSummary } from '@tiptap/extension-details';
import { Table, TableRow, TableCell, TableHeader } from '@tiptap/extension-table';
import Callout from '../extensions/CalloutNode';
import ColumnsNode from '../extensions/ColumnsNode';
import ColumnNode from '../extensions/ColumnNode';

// Advanced Tracking Extensions
import UniqueId from '@tiptap/extension-unique-id';
import Mention from '@tiptap/extension-mention';
import TableOfContents from '@tiptap/extension-table-of-contents';

const lowlight = createLowlight(common);

/**
 * Returns the standardized array of Tiptap extensions for Alphafocus.
 * @param {string} placeholderText - Default placeholder overlay text
 */
export const getEditorExtensions = (placeholderText = 'Start writing, or type / for commands...') => [
    StarterKit.configure({
        heading: { levels: [1, 2, 3] },
        codeBlock: false, // replaced by CodeBlockLowlight
    }),
    Highlight.configure({ multicolor: true }),
    Underline,
    Placeholder.configure({ placeholder: placeholderText }),
    TaskList,
    TaskItem.configure({ nested: true }),
    TextStyle,
    Color,
    Image.configure({
        inline: false,
        allowBase64: true,
        HTMLAttributes: { class: 'tiptap-image' },
    }),
    CodeBlockLowlight.configure({ lowlight }),
    Typography,
    Superscript,
    Subscript,
    Details,
    DetailsContent,
    DetailsSummary,
    Table.configure({ resizable: true }),
    TableRow,
    TableCell,
    TableHeader,
    Callout,
    ColumnsNode,
    ColumnNode,
    UniqueId.configure({
        types: ['heading', 'paragraph', 'codeBlock', 'callout', 'image', 'table', 'columns', 'column', 'taskItem', 'bulletList', 'orderedList', 'blockquote', 'details'],
    }),
    Mention.configure({
        HTMLAttributes: { class: 'tiptap-mention' },
    }),
    TableOfContents,
];
